module.exports = __webpack_public_path__ + "static/media/Table.072ecae5.scss";


//////////////////
// WEBPACK FOOTER
// ./src/system/containers/Table/Table.scss
// module id = 1231
// module chunks = 0